import { UserActions } from '@maggie/store/user/actions';

import type { BackboneEventHandler } from '../backboneListener';

export const backboneResumeActiveEventHandler: BackboneEventHandler = store => {
  return () => {
    store.dispatch(UserActions.updateOpenedDateAction());
  };
};
